import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import { AMMAN_CENTER } from "@/lib/constants";

// Fix marker icons for leaflet in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function Clicker({ onPick }) {
  useMapEvents({
    click(e) { onPick?.({ lat: e.latlng.lat, lng: e.latlng.lng }); },
  });
  return null;
}

function Recenter({ pos }) {
  const map = useMap();
  useEffect(() => { if (pos) map.flyTo([pos.lat, pos.lng], 14, { duration: 0.6 }); }, [pos, map]);
  return null;
}

export default function MapPicker({ value, onChange, height = 320, interactive = true, center }) {
  const c = value || center || AMMAN_CENTER;
  return (
    <div style={{ height }} className="rounded-xl overflow-hidden border border-slate-200">
      <MapContainer center={[c.lat, c.lng]} zoom={11} style={{ height: "100%", width: "100%" }} scrollWheelZoom={interactive}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {interactive && <Clicker onPick={onChange} />}
        {value && <Marker position={[value.lat, value.lng]} />}
        {value && <Recenter pos={value} />}
      </MapContainer>
    </div>
  );
}
